import React from 'react'
import { Icon } from 'semantic-ui-react'
import { Link } from 'react-router-dom'

import moment from 'moment'
import { Fragment } from 'react'

const VocationalTrainerMatrix = ({
  isViewAsTeacher,
  matrices,
  setQTarget,
  setQType,
  toogleShowConfirmModal,
}) => {
  return matrices && matrices.length > 0 ? (
    <ul className='container p-0'>
      {matrices
        .sort((a, b) => {
          let dateA = moment(a.matrix_upload_date, 'MM/YYYY')
          let dateB = moment(b.matrix_upload_date, 'MM/YYYY')
          return dateB.diff(dateA)
        })
        .map((mtx, index, array) => {
          return (
            <li key={mtx._id} className='p-0'>
              <div className='row'>
                <div className='col-8'>
                  <p className='mb-2 profile-qualification-title text-left'>
                    {mtx.matrix_filename}
                  </p>

                  <p className='profile-qualification-place text-left'>
                    <Icon name='file text outline'> </Icon>

                    <Fragment>
                      {mtx.matrix_url ? (
                        <Link
                          to={{
                            pathname: `/NavigateToFileViewer?fileurl=${mtx.matrix_url}`,
                          }}
                          target='_blank'
                        >
                          Matrix
                        </Link>
                      ) : (
                        ''
                      )}
                    </Fragment>
                  </p>
                </div>

                <div className='col-4'>
                  <p className='mt-0 mb-0 profile-qualification-title text-right'>
                    {
                      // mtx.matrix_upload_date.length === 7 ?
                      moment(mtx.matrix_upload_date, 'MM/YYYY').format('MMM YYYY')
                      // : 'NaN'
                    }
                  </p>

                  {isViewAsTeacher ? (
                    <p className='mb-0 profile-qualification-title text-right mt-2'>
                      <Icon
                        name='trash'
                        circular
                        inverted
                        color='grey'
                        onClick={() => {
                          setQTarget(mtx)
                          setQType('VTM')
                          toogleShowConfirmModal(true)
                        }}
                        className='qualification-container-update-icon'
                      >
                        {' '}
                      </Icon>
                    </p>
                  ) : null}
                </div>
                {index !== array.length - 1 && (
                  <div className='col-12'>
                    <hr className='qualification-line-1 my-3'></hr>
                  </div>
                )}
              </div>
            </li>
          )
        })}
    </ul>
  ) : null
}

export default VocationalTrainerMatrix
